<template>
  <div>
    <a-modal
      @cancel="handleCancel"
      :title="$t('support.supportRequest')"
      :visible="$props.supportVisibility"
    >
      <template slot="footer">
        <a-button key="back" @click="handleCancel">{{ $t('support.cancel') }}</a-button>
        <a-button key="submit" type="primary" :loading="loading" @click="handleSubmit">
          {{ $t('support.submit') }}
        </a-button>
      </template>
      <a-form layout="vertical" :form="form">
        <a-form-item>
          <label class="font-bold" slot="label">Tipologia richiesta</label>
          <a-select
            v-decorator="[
              'reason',
              { rules: [{ required: true, message: 'Seleziona il tipo di richiesta' }] }
            ]"
            placeholder="Selezione un opzione"
          >
            <a-select-option v-for="d in supportReasonList" :key="d.id">
              {{ d.description }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item>
          <label class="font-bold" slot="label">Richiesta</label>
          <a-input
            type="textarea"
            v-decorator="[
              'message',
              {
                rules: [
                  { required: true, message: 'Inserisci la richiesta' },
                  { max: 5000, message: 'Richiesta troppo lunga' }
                ]
              }
            ]"
            :autoSize="{ minRows: 5 }"
          />
        </a-form-item>
        <a-form-item v-if="!$props.quotationId">
          <label class="font-bold" slot="label">Nome e Cognome</label>
          <a-input
            type="input"
            v-decorator="[
              'name',
              { rules: [{ required: true, message: 'Inserisci il tuo nome' }] }
            ]"
          />
        </a-form-item>
        <a-form-item v-if="!$props.quotationId">
          <label class="font-bold" slot="label">Indirizzo email</label>
          <a-input
            html-type="email"
            v-decorator="[
              'email',
              {
                rules: [
                  { required: true, message: $t('msg.required') },
                  { type: 'email', message: $t('msg.requiredemail') }
                ]
              }
            ]"
          />
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import api from '@/api.js';

export default {
  name: 'support-request',
  components: {},
  props: ['supportVisibility', 'quotationId'],
  data: function() {
    return {
      ModalText: 'Content of the modal',
      loading: false,
      supportReasonList: [],
      selected: ''
    };
  },
  beforeCreate() {
    this.form = this.$form.createForm(this, { name: 'form_in_modal' });
  },
  watch: {
    supportVisibility: function() {
      if (this.$props.supportVisibility == true) {
        this.getSupportReasonList();
        this.form.resetFields();
      }
    }
  },
  computed: {},
  methods: {
    handleCancel() {
      // emit cancel request
      this.$emit('onCloseSupport');
    },
    getSupportReasonList: async function() {
      let browserLanguage = window.navigator.language && window.navigator.language.split('-')[0];
      let res = await api.getSupportReasonList({
        languageCode: browserLanguage
      });
      this.supportReasonList = res.data.map((item, index) => ({
        ...item,
        index
      }));
    },
    handleSubmit(e) {
      e.preventDefault();
      const form = this.form;
      this.loading = true;
      form.validateFields(async (err, values) => {
        if (err) {
          this.loading = false;
          return;
        }

        // get filtered reason for submit
        let filteredReason = this.supportReasonList.filter(item => {
          if (item.id == values.reason) return true;
        });

        let respRequest = await api.sendSupportRequest({
          quotationId: this.$props.quotationId,
          name: values.name,
          email: values.email,
          message: values.message,
          supportReason: filteredReason[0]
        });

        if (respRequest) {
          form.resetFields();
          this.$emit('onCloseSupport');
          this.loading = false;
          this.$notification.success({
            message: this.$t('support.success'),
            duration: 5
          });
        } else {
          form.resetFields();
          this.loading = false;
          this.$notification.error({
            message: this.$t('support.error'),
            duration: 5
          });
        }

        this.$notification.destroy();
      });
    }
  }
};
</script>

<style lang="scss">
@import '@/variables.scss';
</style>
